module.exports = __webpack_public_path__ + "img/course_0012.8f25eba.webp";